import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import { font, FontFamilyProps } from './font';

import AeonikLight from '../../form/src/fonts/Aeonik-Light.woff2';
import AeonikRegular from '../../form/src/fonts/Aeonik-Regular.woff2';
import AeonikBold from '../../form/src/fonts/Aeonik-Bold.woff2';
import { colors } from './color';

export const GlobalStyle = createGlobalStyle<{ fontFamily?: FontFamilyProps }>`
  ${normalize}

  @font-face {
    font-family: 'Aeonik-Light';
    src: url(${AeonikLight}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Aeonik-Regular';
    src: url(${AeonikRegular}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Aeonik-Bold';
    src: url(${AeonikBold}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
  
  * {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }
  
  body {
    font-family: ${({ fontFamily }) => (fontFamily ? font.family[fontFamily] : font.family.primary)};
    font-weight: ${font.weight.normal};
    font-size: ${font.size.md}px;
    color: ${colors?.primary};
  }

  .custom-hyperlink {
    color: ${colors?.tertiaryBlue}; 
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  .custom-asterisk{
    color: ${colors?.error};
  }

  input, textarea {
    color: ${colors?.primary};
  }


  @media print {
    * {
      -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
      color-adjust: exact !important;                 /* Firefox 48 – 96 */
      print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
    }
  }

  .underline {
    text-decoration: underline;
  }

  .privacy-statement {
    & > p:first-child {
      text-align: center;
      text-decoration: underline;
    }

    & > strong + p {
      margin-block-start: 0;
    }

    ul {
      margin-block: 0;
    }

    strong {
      font-family: 'Aeonik-Bold';
    }

    a {
      color: ${colors?.tertiaryBlue}; 
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  
`;

export default GlobalStyle;
